// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { activeStateTrue } from "@conklin/App/Widgets/SearchEngineOptimization/ActiveState";
import { SeoAppProps, SeoHandlerProps } from "@conklin/App/Widgets/SearchEngineOptimization/Type";
import { Organization, WithContext } from "@conklin/App/Widgets/SearchEngineOptimization/Type/schema";

/**
 * Build the structured data
 */
const loadSchemaOrganization = ({ state, fields, url }: SeoAppProps): WithContext<Organization> => {
    const sameAs = fields.socialLinks.map(item => item.fields.url) || [];

    return {
        "@context": "https://schema.org",
        "@type": "Organization",
        member: [
            {
                "@type": "Organization",
            },
            {
                "@type": "Organization",
            },
        ],
        url,
        name: fields.organizationName || state.context.website.name,
        description: fields.description,
        telephone: fields.telephone,
        email: fields.email,
        faxNumber: fields.faxNumber,
        address: {
            "@type": "PostalAddress",
            addressLocality: fields.addressLocality,
            postalCode: fields.postalCode,
            streetAddress: fields.streetAddress,
        },
        logo: {
            "@type": "ImageObject",
            url: fields.logoUrl,
            name: fields.organizationName || state.context.website.name,
        },
        contactPoint: [
            {
                "@type": "ContactPoint",
                telephone: fields.telephone,
                contactType: "Customer Service",
            },
        ],
        sameAs,
    };
};

export default {
    isActivate: activeStateTrue,
    buildSchema: loadSchemaOrganization,
} as SeoHandlerProps;
